import React, { PropsWithChildren, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { DEFAULT_LOCALE } from 'common/constants/locales';
import { useLocale } from 'store/features/application';

import useGetTranslates from './useGetTranslates';
import { setLocale } from '../storageLocale';

const Translations = (props: PropsWithChildren) => {
  const { children } = props;

  const currentLocale = useLocale();
  const translates = useGetTranslates(currentLocale);
  useEffect(() => {
    document.documentElement.lang = currentLocale;
    setLocale(currentLocale);
  }, [currentLocale]);

  return (
    <IntlProvider
      locale={currentLocale}
      defaultLocale={DEFAULT_LOCALE}
      messages={translates}
    >
      {children}
    </IntlProvider>
  );
};

export default Translations;
